import { useEffect, useState } from 'react';
import { Checkbox } from '@habitech/selectors';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/RootState';
import { Button, DropdownButton } from '@habitech/call-to-action';
import { GridItem } from 'src/components/common/grids';
import Modal from 'src/components/common/modal/Modal'
import Table from 'src/components/common/tables';
import { TableRow } from 'src/components/common/tables/TableRow';
import { TableCell } from 'src/components/common/tables/TableCell';
import { TableHeader } from 'src/components/common/tables/TableHeader';
import { getScoringPrograms } from 'src/apis/scoringPrograms';
import Title from 'src/components/common/Title';
import Loading from 'src/components/common/Loading/Loading';
import { Container } from './styles';
import { TextModal, WrapperButton } from '../styles'
import { postEntitiesRewards } from 'src/apis/programsAssignment';


const initStateModal = {
    show: false,
    text: '',
    success: false,
};

const PropertyList = ({ list, setList }) => {
    const token = useSelector((state: RootState) => state.User.token);
    const [programs, setPrograms] = useState<any>([]);
    const [modal, setModal] = useState(initStateModal);
    const [selected, setSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [idProgram, setIdProgram] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setModal(initStateModal);
        if (modal.success) {
            setList([])
        }
    };

    const handleCheckboxChange = (id: string) => {
        const isChecked = selected.includes(id);
        if (isChecked) {
            setSelected(selected.filter((item) => item !== id));
        } else {
            setSelected([...selected, id]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelected([]);
        } else {
            const allUserIds = list.map((item) => item.property_id);
            setSelected(allUserIds);
        }
        setSelectAll(!selectAll);
    };

    useEffect(() => {
        getScoringPrograms({ token }).then((res) => {
            const active = res?.data?.filter((item) => item.is_active === 1);
            const data = active.map(({ id, name, number_score }) => ({ label: name, value: id, reward_id: id, reward_score: number_score }));
            setPrograms(data || []);
        });
    }, [token]);


    const handleSend = () => {
        if (selected.length > 0 && idProgram) {
            const program = programs.filter(({ value }) => value === idProgram);
            const data = {
                properties_id_list: selected,
                reward_id: program[0].reward_id,
                reward_score: program[0].reward_score
            }
            setLoading(true);
            postEntitiesRewards(data, token)
                .then((res) => {
                    const inserted = res.Inserted.length || 0;
                    const notInserted = res.Not_allowed.length || 0;
                    setModal({
                        show: true,
                        text: `Se añadieron ${inserted} propiedad(es) con exito${notInserted ? `, y ${notInserted} ya tenia(n) este programa ` : '.'} `,
                        success: true,
                    });
                    setLoading(false);
                })
                .catch((e) => {
                    console.error(e);
                    setModal({
                        show: true,
                        text: 'Hubo un error al enviar el programa',
                        success: false,
                    });
                    setLoading(false);
                });
        }
        else {
            setModal({
                show: true,
                text: `Error: 
                    ${!idProgram ? ' * debe seleccionar un programa  -' : ''}
                    ${selected.length < 1 ? ' * debe seleccionar una propiedad' : ''}`,
                success: false,
            });
        }
    }


    return (
        <Container>
            <GridItem>
                <Title>Listado de propiedades</Title>
            </GridItem>
            <GridItem>
                <Table className='table-properties'>
                    <thead>
                        <TableHeader>
                            <Checkbox
                                dataId="test-data-id"
                                id="test-id"
                                name="test-name"
                                onChange={handleSelectAll}
                                originType="pcom"
                                type="default"
                                value="test-value"
                                selected={selectAll}
                            />
                        </TableHeader>
                        {['ID', 'Colonia', 'Ciudad', 'Estado', 'Email'].map((item) => (
                            <TableHeader key={item}>{item}</TableHeader>
                        ))}
                    </thead>
                    <tbody>
                        {list.map(({ property_id, colony, city, state, user_email }) => (
                            <TableRow key={`row-codes-${property_id}`}>
                                <TableCell>
                                    <Checkbox
                                        dataId="test-data-id"
                                        id="test-id"
                                        name="test-name"
                                        originType="pcom"
                                        type="default"
                                        value="test-value"
                                        selected={selected.includes(property_id)}
                                        onChange={() => handleCheckboxChange(property_id)}
                                    />
                                </TableCell>
                                <TableCell>{property_id}</TableCell>
                                <TableCell>{colony}</TableCell>
                                <TableCell>{city}</TableCell>
                                <TableCell>{state}
                                </TableCell>
                                <TableCell>{user_email}
                                </TableCell>
                            </TableRow>
                        ))}
                    </tbody>
                </Table>
            </GridItem>
            <GridItem>
                <p><b>{selected.length}</b> - Propiedades seleccionadas</p>
            </GridItem>
            <div className='programs'>
                <DropdownButton
                    dataId="test_id"
                    label="Selecciona un programa de recompensa"
                    listOptions={programs}
                    placeholder="Seleccione"
                    setValue={(val) => setIdProgram(val)}
                    variant="white"
                    originType='pcom'
                    size='large fluid'
                />
                {loading ?
                    <Loading className="loader-button" /> :
                    <Button dataId='add-programs' originType='pcom' size='extra-large' onClick={handleSend}>
                        Aplicar
                    </Button>
                }

            </div>

            {modal.show && (
                <Modal onClose={handleClose}>
                    <div style={{ margin: '48px 0 24px' }}>
                        <TextModal>{modal.text}</TextModal>
                        <WrapperButton>
                            <Button dataId="button-search" originType="pcom" size="large" onClick={handleClose}>
                                Aceptar
                            </Button>
                        </WrapperButton>
                    </div>
                </Modal>
            )}
        </Container>
    );
};

export default PropertyList;
